module.exports = __webpack_public_path__ + "media/images/logo/logo_lava-538b11c607ff6037fe580641d6e399d7.png";